<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M189.191 150.976L167.872 135.194C167.04 125.376 163.456 115.834 157.063 107.52C155.047 104.896 150.829 104.09 150.375 103.546C146.675 99.1104 141.613 107.085 137.658 115.59C134.893 115.603 132.173 116.646 130.074 118.611H119.591V119.072L35.6291 29.3696C30.5283 23.9168 21.8947 23.6352 16.4419 28.736C10.9891 33.8368 10.7075 42.4704 15.8083 47.9232L108.691 147.142L96.8643 163.117C94.8099 165.894 94.2339 169.306 94.9955 172.416L93.3635 174.259L66.0931 174.413C77.8307 186.752 89.0883 193.709 100.019 196.058C106.944 197.542 114.675 197.248 122.093 195.674L144.051 211.936C149.005 215.603 155.994 214.56 159.661 209.606L191.52 166.579C195.187 161.626 194.144 154.637 189.191 150.97V150.976Z"
      class="fill-brand-100"
    />
    <path
      d="M118.183 2.56H40.4931C34.3146 2.56 29.3059 7.56868 29.3059 13.7472V176.986C29.3059 183.164 34.3146 188.173 40.4931 188.173H118.183C124.361 188.173 129.37 183.164 129.37 176.986V13.7472C129.37 7.56868 124.361 2.56 118.183 2.56Z"
      class="fill-secondary-500"
    />
    <path
      d="M113.856 12.6144H44.8131C41.9678 12.6144 39.6611 14.921 39.6611 17.7664V172.966C39.6611 175.812 41.9678 178.118 44.8131 178.118H113.856C116.702 178.118 119.008 175.812 119.008 172.966V17.7664C119.008 14.921 116.702 12.6144 113.856 12.6144Z"
      class="fill-brand-500"
    />
    <path
      d="M99.1555 148.154H59.5139C55.336 148.154 51.9491 151.54 51.9491 155.718V155.725C51.9491 159.903 55.336 163.29 59.5139 163.29H99.1555C103.333 163.29 106.72 159.903 106.72 155.725V155.718C106.72 151.54 103.333 148.154 99.1555 148.154Z"
      class="fill-brand-300"
    />
    <path
      d="M124.182 66.2758C119.227 60.0598 110.171 59.0376 103.955 63.9927C97.7389 68.9478 96.7167 78.0038 101.672 84.2199L134.747 125.712C139.703 131.928 148.759 132.951 154.975 127.995C161.191 123.04 162.213 113.984 157.258 107.768L124.182 66.2758Z"
      class="fill-brand-100"
    />
    <path
      d="M124.186 66.2784C120.455 61.6 114.349 59.872 108.909 61.44C108.839 64.1152 109.491 68.0512 110.88 70.208C114.381 75.6544 119.885 80.2944 119.885 80.2944C121.402 82.0416 124.205 81.5296 126.074 79.9104L128.685 77.024C129.511 76.2048 130.24 75.3792 130.823 74.6112L124.179 66.2784H124.186Z"
      class="fill-brand-300"
    />
    <path
      d="M42.9699 132.672C48.5763 127.066 48.5763 117.971 42.9699 112.365L39.8979 109.293C40.9987 108.672 42.0355 107.904 42.9699 106.97C48.5763 101.363 48.5763 92.2688 42.9699 86.6624L38.5987 82.2912C32.9923 76.6848 23.8979 76.6848 18.2915 82.2912C12.6851 87.8976 12.6851 96.992 18.2915 102.598L21.3635 105.67C20.2627 106.291 19.2259 107.059 18.2915 107.994C12.6851 113.6 12.6851 122.694 18.2915 128.301L20.6275 130.637C19.7059 131.194 18.8227 131.853 18.0291 132.653C12.7683 137.914 12.7683 146.438 18.0291 151.693L22.1315 155.795C27.3923 161.056 35.9171 161.056 41.1715 155.795C46.4323 150.534 46.4323 142.01 41.1715 136.755L39.5971 135.181C40.8067 134.528 41.9523 133.702 42.9699 132.678V132.672Z"
      class="fill-brand-100"
    />
    <path
      d="M125.591 204.705L176.909 135.404L235.657 178.906C240.018 182.136 240.936 188.295 237.707 192.656L198.089 246.158C194.859 250.519 188.7 251.437 184.339 248.208L125.591 204.705Z"
      class="fill-secondary-500"
    />
    <path
      d="M71.7379 76.4672C71.6739 76.4672 71.6099 76.4672 71.5395 76.4672C69.7539 76.416 68.0643 75.6416 66.8611 74.3168L53.4019 59.5648C50.9443 56.8704 51.1363 52.6976 53.8307 50.24C56.5251 47.7824 60.6979 47.9744 63.1555 50.6688L72.0195 60.384L95.7954 37.2416C98.4066 34.7008 102.586 34.752 105.127 37.3696C107.667 39.9808 107.616 44.16 104.999 46.7008L76.3331 74.6048C75.0979 75.808 73.4467 76.4736 71.7315 76.4736L71.7379 76.4672Z"
      class="fill-brand-300"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Application'
  }
</script>
